import * as user from './user';

export default {
    user,
};
